import { render, staticRenderFns } from "./PaymentSystemsModal.vue?vue&type=template&id=3640a038&scoped=true"
import script from "./PaymentSystemsModal.vue?vue&type=script&lang=js"
export * from "./PaymentSystemsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3640a038",
  null
  
)

export default component.exports